module.exports = __webpack_public_path__ + "e6cef65982.woff2";